import { BiHotel } from 'react-icons/bi';
import { TiWaves } from 'react-icons/ti';
import { IoMdAirplane } from 'react-icons/io';
import { AiTwotoneCar } from 'react-icons/ai';
import PropTypes from 'prop-types';
import { CircularProgress } from '@material-ui/core';
import InfoDropdownPopover from '../InfoDropdownPopover';
import { SearchStatus, AgentTipTypes } from '../../constants';

const AgentTips = ({ agentTips, handleDoShowAgentTip }) => {
  const tips = agentTips ? agentTips.tips : [];

  const iconComponents = {
    0: IoMdAirplane,
    5: BiHotel,
    10: AiTwotoneCar,
    15: TiWaves,
  };

  const height = tips && tips.length === 0 ? 'auto' : '7rem';

  return (
    <div>
      <div className="mx-10 my-5 mb-0 flex justify-between">
        <div className="text-s font-bold">Agent tips</div>
        {tips && tips.length > 0 && (
          <div>
            <InfoDropdownPopover
              onOpen={handleDoShowAgentTip}
              dropdownTextPlaceholder="View all tips"
              rotate="-rotate-90"
              fontSize="text-sm"
            />
          </div>
        )}
      </div>
      <div className="mx-10 my-5 mt-1 flex ">
        <div className=" flex flex-wrap overflow-hidden " style={{ height }}>
          {(tips || []).length === 0 ? (
            <div className="mt-2">No agent tips found for the cruise option</div>
          ) : (
            tips.map((tip, index) => {
              if (tip.itineraries[0]) {
                const IconType = iconComponents[tip.itineraries[0].mode];
                return (
                  // oxlint-disable-next-line react/no-array-index-key
                  <div
                    key={`tip-${tip.tipDescription}${index}`}
                    className="w-96 h-32 bg-gray-100 border border-gray-300 mr-8 pl-2 pt-3 pb-3 pr-2 flex flex-col justify-between w-auto "
                    style={{ width: '205px', height: '7rem' }}
                  >
                    <div className="flex ">
                      <div className="mr-2">
                        <IconType className="text-theme text-3xl" />
                      </div>
                      <div className="text-sm w-full overflow-hidden h-10">
                        <p>{tip.tipDescription}</p>
                      </div>
                    </div>
                    <div className="flex flex-row justify-between items-end">
                      <div className="text-sm font-bold ">
                        {tip.tipType === AgentTipTypes.HotelDealAlert
                          ? `Only $${tip.dealHotelPrice.toFixed(0)}`
                          : `Save up to $${tip.tipSaving.toFixed(0)}`}
                      </div>
                      <div>
                        {/* TODO: Why is InfoDropdownPopover component used here??? */}
                        <InfoDropdownPopover
                          onOpen={() => handleDoShowAgentTip(index)}
                          dropdownTextPlaceholder="View tip"
                          rotate="-rotate-90"
                          fontSize="text-sm"
                        />
                      </div>
                    </div>
                  </div>
                );
              }
              return null;
            })
          )}
        </div>
        <div className=" flex items-center">
          {(!agentTips ||
            agentTips.status === SearchStatus.INITIAL ||
            agentTips.status === SearchStatus.SEARCHING) && (
            <div className="text-center">
              <CircularProgress color="secondary" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

AgentTips.propTypes = {
  agentTips: PropTypes.shape({
    status: PropTypes.number,
    tips: PropTypes.arrayOf(PropTypes.objectOf),
  }).isRequired,
  handleDoShowAgentTip: PropTypes.func.isRequired,
};

export default AgentTips;
